export default __webpack_public_path__ + "static/screen_3_02-87f8c3b7cdcb5e5534371fb042d4addc.svg";